// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-task{margin:1.5rem;padding-top:20%;color:#d6d5d5;text-align:center}.no-task .fas{font-size:8em}", ""]);
// Exports
module.exports = exports;
